export const GET_POPULAR_MATCHES = 'GET_POPULAR_MATCHES';
export const SUCCESS_GET_POPULAR_MATCHES = 'SUCCESS_GET_POPULAR_MATCHES';
export const FAILURE_GET_POPULAR_MATCHES = 'FAILURE_GET_POPULAR_MATCHES';



// WEBPACK FOOTER //
// ./js/actions/Popular.js